import React from 'react'
import { SvgIcon } from '@mui/material'

export const SaturationIcon = () => (
  <SvgIcon
    viewBox="0 0 16 16"
    sx={{ height: '16px', width: '16px', color: 'white' }}
  >
    <path
      d="M8.00008 13.0532C6.93341 13.0532 5.92675 12.6399 5.17341 11.8865C4.41341 11.1265 4.00008 10.1265 4.00008 9.05318C4.00008 7.99985 4.41341 6.97985 5.17341 6.22652L8.00008 3.39985M11.7734 5.28652L8.00008 1.51318L4.22675 5.28652C2.14675 7.36652 2.14675 10.7465 4.22675 12.8265C5.26675 13.8665 6.63341 14.3865 8.00008 14.3865C9.36675 14.3865 10.7334 13.8665 11.7734 12.8265C13.8534 10.7465 13.8534 7.36652 11.7734 5.28652Z"
      fill="white"
    />
  </SvgIcon>
)
